import React from "react";
import { Typography, Tooltip } from "@mui/material";

// Map insight types to appropriate emoji/icon
const getInsightIcon = (insightType) => {
  const lowerCaseType = insightType.toLowerCase();
  
  if (lowerCaseType.includes("rage click")) return "😠";
  if (lowerCaseType.includes("dead click")) return "🚫";
  if (lowerCaseType.includes("scroll")) return "📜";
  if (lowerCaseType.includes("abandon")) return "🚶";
  if (lowerCaseType.includes("quick back click")) return "🚪";
  if (lowerCaseType.includes("time")) return "⏱️";
  if (lowerCaseType.includes("conversion")) return "✅";
  
  // Default icon if no match
  return "ℹ️";
};

const Insights = ({ analyticsData, themeBg }) => {
  const insights = analyticsData?.engagement?.insights || [];

  return (
    <div
      style={{
        backgroundColor: themeBg || "#EDDEA4",
        borderRadius: "12px",
        padding: "20px",
        color: "#FFFFFF",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Header section */}
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "15px",
          color: "#353535",
          borderBottom: "2px solid rgba(0, 0, 0, 0.2)",
          paddingBottom: "10px"
        }}
      >
        User Engagement Insights
      </Typography>
      
      {/* Column headers */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 0",
          marginBottom: "5px",
          fontWeight: "bold",
        }}
      >
        <Typography
          variant="body2"
          style={{
            flex: "1 1 60%",
            fontSize: "13px",
            color: "#353535",
            paddingLeft: "4px",
          }}
        >
          Insight Type
        </Typography>
        <div style={{ 
          display: "flex", 
          flex: "1 1 40%",
          justifyContent: "flex-end",
          gap: "20px"
        }}>
          <Typography
            variant="body2"
            style={{
              fontSize: "13px",
              color: "#353535",
              textAlign: "right",
              width: "60px",
            }}
          >
            Sessions
          </Typography>
          <Typography
            variant="body2"
            style={{
              fontSize: "13px",
              color: "#353535",
              textAlign: "right",
              width: "50px",
            }}
          >
            % Total
          </Typography>
        </div>
      </div>

      {/* Insights rows with improved spacing and alignment */}
      {insights.length > 0 ? (
        insights.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 0", // Increased vertical padding
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
              backgroundColor: index % 2 === 0 ? "rgba(0, 0, 0, 0.04)" : "transparent", // Subtle zebra striping
            }}
          >
            {/* Left-aligned insight label with emoji */}
            <Typography
              variant="body2"
              style={{
                flex: "1 1 60%", // Allow growing but maintain proportions
                fontSize: "14px",
                fontWeight: "500",
                color: "#19922D",
                paddingLeft: "4px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <Tooltip title={item.insight} placement="top">
                <span style={{ fontSize: "16px" }}>
                  {getInsightIcon(item.insight)}
                </span>
              </Tooltip>
              {item.insight}
            </Typography>

            {/* Right-aligned metrics in a container */}
            <div style={{ 
              display: "flex", 
              flex: "1 1 40%",
              justifyContent: "flex-end",
              gap: "20px"
            }}>
              {/* Sessions count */}
              <Typography
                variant="body2"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#353535",
                  textAlign: "right",
                  width: "60px", // Fixed width for alignment
                }}
              >
                {item.sessions}
              </Typography>

              {/* Sessions percentage */}
              <Typography
                variant="body2"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#A53860",
                  textAlign: "right",
                  width: "50px", // Fixed width for alignment
                }}
              >
                {item.percentage}
              </Typography>
            </div>
          </div>
        ))
      ) : (
        <Typography
          variant="body2"
          style={{
            textAlign: "center",
            marginTop: "20px",
            color: "#555"
          }}
        >
          No insight data available
        </Typography>
      )}
    </div>
  );
};

export default Insights;
